import { QuestionnaireTypes } from './actions';
import { IAllQuestionnaire } from '../../api/models/Questionnaire';

interface IQuestionnaireState {
  loading: boolean | null,
  error: any | null,
  questionnaireList: IAllQuestionnaire | null,
  activeQuestionnaire: any,
  activeQuestionnaireQuestions: any
}

const initialState: IQuestionnaireState = {
  loading: null,
  error: null,
  questionnaireList: null,
  activeQuestionnaire: null,
  activeQuestionnaireQuestions: null,
};

export const questionnaireReducer = (state = initialState,
  action: { type: string, payload?: any }) => {
  const { type, payload } = action;
  switch (type) {
    case QuestionnaireTypes.CREATE_QUESTIONNAIRE:
      return {
        ...state,
        loading: true,
      };
    case QuestionnaireTypes.CREATE_QUESTIONNAIRE_SUCCESS:
      return {
        ...state,
        activeQuestionnaire: { ...payload },
        loading: false,
      };
    case QuestionnaireTypes.CREATE_QUESTIONNAIRE_FAILURE:
      return {
        ...state,
        error: { ...payload },
        loading: false,
      };
    case QuestionnaireTypes.PUT_QUESTIONNAIRE:
      return {
        ...state,
        loading: true,
      };
    case QuestionnaireTypes.PUT_QUESTIONNAIRE_SUCCESS:
      return {
        ...state,
        activeQuestionnaire: { ...payload },
        loading: false,
      };
    case QuestionnaireTypes.PUT_QUESTIONNAIRE_FAILURE:
      return {
        ...state,
        error: { ...payload },
        loading: false,
      };
    case QuestionnaireTypes.GET_QUESTIONS:
      return {
        ...state,
        loading: true,
      };
    case QuestionnaireTypes.GET_QUESTIONS_SUCCESS:
      return {
        ...state,
        activeQuestionnaireQuestions: { ...payload },
        loading: false,
      };
    case QuestionnaireTypes.GET_QUESTIONS_FAILURE:
      return {
        ...state,
        error: { ...payload },
        loading: false,
      };
    case QuestionnaireTypes.GET_QUESTIONNAIRE:
      return {
        ...state,
        loading: true,
      };
    case QuestionnaireTypes.GET_QUESTIONNAIRE_SUCCESS:
      return {
        ...state,
        activeQuestionnaire: { ...payload },
        loading: false,
      };
    case QuestionnaireTypes.GET_QUESTIONNAIRE_FAILURE:
      return {
        ...state,
        error: { ...payload },
        loading: false,
      };
    case QuestionnaireTypes.GET_QUESTIONNAIRE_LIST:
      return {
        ...state,
        loading: true,
      };
    case QuestionnaireTypes.GET_QUESTIONNAIRE_LIST_SUCCESS:
      return {
        ...state,
        questionnaireList: { ...payload },
        loading: false,
      };
    case QuestionnaireTypes.GET_QUESTIONNAIRE_LIST_FAILURE:
      return {
        ...state,
        error: { ...payload },
        loading: false,
      };
    case QuestionnaireTypes.RESET:
      return {
        ...state,
        error: null,
        activeQuestionnaire: null,
        activeQuestionnaireQuestions: null,
      };
    default:
      return state;
  }
};

export default questionnaireReducer;
